import { DefaultService } from '@/services/DefaultService';

export default class AssFormaPagamentoB2BEmpresaService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAll(column, order, page, limit, situacao, idEmpresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/b2b/b2bempresa/assformapagto.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idEmpresa=${idEmpresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
	}

    find(id) {
		return this._http.get(`${this._env}/b2b/b2bempresa/assformapagto/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
	}

    updateSituacao(assFormaPagtoB2BEmpresa) {
        console.log(assFormaPagtoB2BEmpresa)
        const { idb2b_assempresaformapagto: idB2BAssEmpresaFormaPagamento, ...rest } = assFormaPagtoB2BEmpresa;

        return this._http.post(`${this._env}/b2b/b2bempresa/assformapagto/updatesituacao`, { idB2BAssEmpresaFormaPagamento, ...rest }, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }

    save(assFormaPagtoB2BEmpresa) {
        return this._http.post(`${this._env}/b2b/b2bempresa/assformapagto`, assFormaPagtoB2BEmpresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }

    insertBulk(assFormaPagtoB2BEmpresa) {
        return this._http.post(`${this._env}/b2b/b2bempresa/assformapagto/insert-bulk`, assFormaPagtoB2BEmpresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }
}